import * as React from "react";

function merge(refs: unknown[], element: unknown) {
  refs.forEach((ref) => {
    if (typeof ref === "function") {
      ref(element);
    } else if (ref != null) {
      (ref as React.MutableRefObject<unknown>).current = element;
    }
  });
}

export function useMergeRefs(...args: unknown[]) {
  const callbackRef = React.useCallback(
    (element: unknown) => {
      merge(args, element);
    },
    [args],
  );

  return callbackRef;
}
